// Helper function used only by the trading-service at this time. It takes a position's
// symbol and checks to see if it has an adjusted root vs the provided legRootSymbol.

import { WeeklyIndexUnderliers } from "../../models/option/trading-option.model";

// That is, after removing the legRootSymbol from the candidate, is what's left a digit.
export function isAdjustedSymbol(positionSymbol:string, legRootSymbol:string): boolean {
    // Return false when the legRootSymbol doesn't match the start of the position symbol
    // If we don't do this, and the legRootSymbol length is the same as the non-numeric
    // part of an option symbol's root, we'll get a false positive when lines 19-20 execute
    if ( positionSymbol.indexOf(legRootSymbol) !== 0 ) {
        return false;
    }

    // check that we're not dealing with a full option symbol as our candidate,
    // and truncate after the first space if we are
    let candidateSymbol: string = positionSymbol;
    if ( candidateSymbol.indexOf(' C ') !== -1 || candidateSymbol.indexOf(' P ') !== -1 ) {
        candidateSymbol = candidateSymbol.substring(0, candidateSymbol.indexOf(' '));
    }
    let adjustedLegVal: any = '';
    adjustedLegVal = candidateSymbol.substring(legRootSymbol.length);
    return (adjustedLegVal != '' && !isNaN(adjustedLegVal));
}


export function isUnderlyingAdjustedOrIndexSymbol(symbol: string): boolean {
    let dataFromSymbol: any = symbol.substring(symbol.length-1);

    // OE3714 -- Don't check for last character "W" or "P", use the new WeeklyIndexUnderliers Map
    // to see if it has a property for the full symbol value. This will correctly mark one of our
    // four valid weekly index symbols (NDXP, RUTW, SPXW, VIXW) and leave symbols like COP and
    // SHOP alone.
    if (WeeklyIndexUnderliers.hasOwnProperty(symbol) || !isNaN(dataFromSymbol)) {
        return true;
    } else {
        return false;
    }
    
}